var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.show_menu
      ? _c(
          "nav",
          { class: this.sidemenu_minimized, attrs: { id: "sidebar" } },
          [
            _c("ul", { staticClass: "list-unstyled" }, [
              _vm.loggedInUserRole == "ROLE_MENTEE"
                ? _c(
                    "li",
                    {
                      class: _vm.activeRoute("menteedashboard") ? "active" : ""
                    },
                    [
                      _c(
                        "router-link",
                        { attrs: { to: "/mentee-dashboard" } },
                        [
                          _vm.activeRoute("menteedashboard")
                            ? _c("img", {
                                attrs: {
                                  src: require("@/assets/manager/home_icon_dashboard_selected.png")
                                }
                              })
                            : _c("img", {
                                attrs: {
                                  src: require("@/assets/manager/home_icon_dashboard_not_selected.png")
                                }
                              }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass: "menu-item-name",
                              class: _vm.activeRoute("menteedashboard")
                                ? ""
                                : "text-muted"
                            },
                            [_vm._v("Home")]
                          )
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.loggedInUserRole == "ROLE_APPRENTICE"
                ? _c(
                    "li",
                    {
                      class: _vm.activeRoute("apprenticedashboard")
                        ? "active"
                        : ""
                    },
                    [
                      _c(
                        "router-link",
                        { attrs: { to: "/apprentice-dashboard" } },
                        [
                          _vm.activeRoute("apprenticedashboard")
                            ? _c("img", {
                                attrs: {
                                  src: require("@/assets/manager/home_icon_dashboard_selected.png")
                                }
                              })
                            : _c("img", {
                                attrs: {
                                  src: require("@/assets/manager/home_icon_dashboard_not_selected.png")
                                }
                              }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass: "menu-item-name",
                              class: _vm.activeRoute("apprenticedashboard")
                                ? ""
                                : "text-muted"
                            },
                            [_vm._v("Home")]
                          )
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "li",
                { class: _vm.activeRoute("menteeReports") ? "active" : "" },
                [
                  _c("router-link", { attrs: { to: "/mentee/reports" } }, [
                    _vm.activeRoute("menteeReports")
                      ? _c("img", {
                          attrs: {
                            src: require("@/assets/manager/reports_selected.png")
                          }
                        })
                      : _c("img", {
                          attrs: {
                            src: require("@/assets/manager/reports_not_selected.png")
                          }
                        }),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "menu-item-name",
                        class: _vm.activeRoute("menteeReports")
                          ? ""
                          : "text-muted"
                      },
                      [_vm._v("Reports")]
                    )
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { class: _vm.activeRoute("myprofile") ? "active" : "" },
                [
                  _c("router-link", { attrs: { to: "/myprofile" } }, [
                    _vm.activeRoute("myprofile")
                      ? _c("img", {
                          attrs: {
                            src: require("@/assets/manager/my_profile_menu_icon_selected.png")
                          }
                        })
                      : _c("img", {
                          attrs: {
                            src: require("@/assets/manager/my_profile_menu_icon_not_selected.png")
                          }
                        }),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "menu-item-name",
                        class: _vm.activeRoute("myprofile") ? "" : "text-muted"
                      },
                      [_vm._v("My Profile")]
                    )
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { class: _vm.activeRoute("mybadges") ? "active" : "" },
                [
                  _c("router-link", { attrs: { to: "/my-badges" } }, [
                    _vm.activeRoute("mybadges")
                      ? _c("img", {
                          attrs: {
                            src: require("@/assets/manager/my_badges_menu_icon_selected.png")
                          }
                        })
                      : _c("img", {
                          attrs: {
                            src: require("@/assets/manager/my_badges_menu_icon_not_selected.png")
                          }
                        }),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "menu-item-name",
                        class: _vm.activeRoute("mybadges") ? "" : "text-muted"
                      },
                      [_vm._v("My Badges")]
                    )
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { class: _vm.activeRoute("logout") ? "active" : "" },
                [
                  _c("router-link", { attrs: { to: "/logout" } }, [
                    _vm.activeRoute("logout")
                      ? _c("img", {
                          attrs: {
                            src: require("@/assets/manager/sign_out_menu_icon.png")
                          }
                        })
                      : _c("img", {
                          attrs: {
                            src: require("@/assets/manager/sign_out_menu_icon.png")
                          }
                        }),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "menu-item-name",
                        class: _vm.activeRoute("logout") ? "" : "text-muted"
                      },
                      [_vm._v("Sign Out")]
                    )
                  ])
                ],
                1
              )
            ])
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.show_back_button
      ? _c(
          "nav",
          {
            class: _vm.show_back_button ? "sidebar_view_mentee" : "",
            attrs: { id: "sidebar" }
          },
          [
            _c("ul", { staticClass: "list-unstyled" }, [
              _vm.loggedInUserRole == "ROLE_MENTEE"
                ? _c(
                    "li",
                    {},
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "text-uppercase text-muted pt-1",
                          attrs: {
                            to: this.back_link
                              ? { name: this.back_link }
                              : "/mentee-dashboard"
                          }
                        },
                        [
                          _c("img", {
                            staticClass: "back_icon mr-2",
                            attrs: {
                              src: require("@/assets/manager/back_button_icon.png")
                            }
                          }),
                          _vm._v("\n          Back\n        ")
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.loggedInUserRole == "ROLE_APPRENTICE"
                ? _c(
                    "li",
                    {},
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "text-uppercase text-muted pt-1",
                          attrs: {
                            to: this.back_link
                              ? { name: this.back_link }
                              : "/apprentice-dashboard"
                          }
                        },
                        [
                          _c("img", {
                            staticClass: "back_icon mr-2",
                            attrs: {
                              src: require("@/assets/manager/back_button_icon.png")
                            }
                          }),
                          _vm._v("\n          Back\n        ")
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ])
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7cf4652e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7cf4652e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/mentee_sidebar_menu.vue
// module id = null
// module chunks = 